import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  last1vo29oleiqj36 as last,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  boxApply1qmzdb3dh90hg as boxApply,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default2o0k93vobxyld as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from '../encoding/Decoding.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from '../encoding/Encoding.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NamedValueDecoderClass;
function NamedValueDecoder() {
  if (NamedValueDecoderClass === VOID) {
    class $ extends TaggedDecoder() {
      s1h(_this__u8e3s4, index) {
        return this.u1h(this.t1h(_this__u8e3s4, index));
      }
      u1h(nestedName) {
        var tmp0_elvis_lhs = this.x1h();
        return this.y1h(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      t1h(descriptor, index) {
        return descriptor.v11(index);
      }
      y1h(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
      z1h() {
        return this.v1h_1.i1() ? '$' : joinToString(this.v1h_1, '.', '$.');
      }
    }
    initMetadataForClass($, 'NamedValueDecoder');
    NamedValueDecoderClass = $;
  }
  return NamedValueDecoderClass;
}
var NamedValueEncoderClass;
function NamedValueEncoder() {
  if (NamedValueEncoderClass === VOID) {
    class $ extends TaggedEncoder() {
      s1h(_this__u8e3s4, index) {
        return this.u1h(this.t1h(_this__u8e3s4, index));
      }
      u1h(nestedName) {
        var tmp0_elvis_lhs = this.x1h();
        return this.y1h(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
      }
      t1h(descriptor, index) {
        return descriptor.v11(index);
      }
      y1h(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) {
          tmp = childName;
        } else {
          tmp = parentName + '.' + childName;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'NamedValueEncoder');
    NamedValueEncoderClass = $;
  }
  return NamedValueEncoderClass;
}
function tagBlock($this, tag, block) {
  $this.n1i(tag);
  var r = block();
  if (!$this.w1h_1) {
    $this.p1i();
  }
  $this.w1h_1 = false;
  return r;
}
var TaggedDecoderClass;
function TaggedDecoder() {
  if (TaggedDecoderClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.v1h_1 = ArrayList().w();
        this.w1h_1 = false;
      }
      mz() {
        return EmptySerializersModule();
      }
      a1i(tag) {
        throw SerializationException().p10(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      b1i(tag) {
        return true;
      }
      c1i(tag) {
        var tmp = this.a1i(tag);
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      d1i(tag) {
        var tmp = this.a1i(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      e1i(tag) {
        var tmp = this.a1i(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      f1i(tag) {
        var tmp = this.a1i(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      g1i(tag) {
        var tmp = this.a1i(tag);
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      h1i(tag) {
        var tmp = this.a1i(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      i1i(tag) {
        var tmp = this.a1i(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      j1i(tag) {
        var tmp = this.a1i(tag);
        return tmp instanceof Char() ? tmp.z2_1 : THROW_CCE();
      }
      k1i(tag) {
        var tmp = this.a1i(tag);
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      l1i(tag, enumDescriptor) {
        var tmp = this.a1i(tag);
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      m1i(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.n1i(tag);
        return this;
      }
      k13(deserializer, previousValue) {
        return this.qz(deserializer);
      }
      j13(descriptor) {
        return this.m1i(this.p1i(), descriptor);
      }
      x12() {
        var tmp0_elvis_lhs = this.x1h();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var currentTag = tmp;
        return this.b1i(currentTag);
      }
      y12() {
        return null;
      }
      z12() {
        return this.c1i(this.p1i());
      }
      a13() {
        return this.d1i(this.p1i());
      }
      b13() {
        return this.e1i(this.p1i());
      }
      c13() {
        return this.f1i(this.p1i());
      }
      d13() {
        return this.g1i(this.p1i());
      }
      e13() {
        return this.h1i(this.p1i());
      }
      f13() {
        return this.i1i(this.p1i());
      }
      g13() {
        return this.j1i(this.p1i());
      }
      h13() {
        return this.k1i(this.p1i());
      }
      i13(enumDescriptor) {
        return this.l1i(this.p1i(), enumDescriptor);
      }
      l13(descriptor) {
        return this;
      }
      m13(descriptor) {
      }
      n13(descriptor, index) {
        return this.c1i(this.s1h(descriptor, index));
      }
      o13(descriptor, index) {
        return this.d1i(this.s1h(descriptor, index));
      }
      p13(descriptor, index) {
        return this.e1i(this.s1h(descriptor, index));
      }
      q13(descriptor, index) {
        return this.f1i(this.s1h(descriptor, index));
      }
      r13(descriptor, index) {
        return this.g1i(this.s1h(descriptor, index));
      }
      s13(descriptor, index) {
        return this.h1i(this.s1h(descriptor, index));
      }
      t13(descriptor, index) {
        return this.i1i(this.s1h(descriptor, index));
      }
      u13(descriptor, index) {
        return this.j1i(this.s1h(descriptor, index));
      }
      v13(descriptor, index) {
        return this.k1i(this.s1h(descriptor, index));
      }
      w13(descriptor, index) {
        return this.m1i(this.s1h(descriptor, index), descriptor.y11(index));
      }
      x13(descriptor, index, deserializer, previousValue) {
        var tmp = this.s1h(descriptor, index);
        return tagBlock(this, tmp, () => this.k13(deserializer, previousValue));
      }
      z13(descriptor, index, deserializer, previousValue) {
        var tmp = this.s1h(descriptor, index);
        return tagBlock(this, tmp, () => {
          // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
          var isNullabilitySupported = deserializer.az().l11();
          var tmp;
          if (isNullabilitySupported || this.x12()) {
            tmp = this.k13(deserializer, previousValue);
          } else {
            tmp = this.y12();
          }
          return tmp;
        });
      }
      x1h() {
        return lastOrNull(this.v1h_1);
      }
      n1i(name) {
        this.v1h_1.v(name);
      }
      o1i(other) {
        other.v1h_1.r1(this.v1h_1);
      }
      p1i() {
        var r = this.v1h_1.z3(get_lastIndex(this.v1h_1));
        this.w1h_1 = true;
        return r;
      }
    }
    protoOf($).y13 = decodeSerializableElement$default;
    protoOf($).qz = decodeSerializableValue;
    protoOf($).a14 = decodeSequentially;
    protoOf($).c14 = decodeCollectionSize;
    initMetadataForClass($, 'TaggedDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    TaggedDecoderClass = $;
  }
  return TaggedDecoderClass;
}
function encodeElement($this, desc, index) {
  var tag = $this.s1h(desc, index);
  $this.n1i(tag);
  return true;
}
var TaggedEncoderClass;
function TaggedEncoder() {
  if (TaggedEncoderClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.r1i_1 = ArrayList().w();
      }
      mz() {
        return EmptySerializersModule();
      }
      s1i(tag, value) {
        throw SerializationException().p10('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
      }
      t1i(tag) {
      }
      u1i(tag) {
        throw SerializationException().p10('null is not supported');
      }
      v1i(tag, value) {
        return this.s1i(tag, value);
      }
      w1i(tag, value) {
        return this.s1i(tag, value);
      }
      x1i(tag, value) {
        return this.s1i(tag, value);
      }
      y1i(tag, value) {
        return this.s1i(tag, value);
      }
      z1i(tag, value) {
        return this.s1i(tag, value);
      }
      a1j(tag, value) {
        return this.s1i(tag, value);
      }
      b1j(tag, value) {
        return this.s1i(tag, value);
      }
      c1j(tag, value) {
        return this.s1i(tag, new (Char())(value));
      }
      d1j(tag, value) {
        return this.s1i(tag, value);
      }
      e1j(tag, enumDescriptor, ordinal) {
        return this.s1i(tag, ordinal);
      }
      f1j(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        this.n1i(tag);
        return this;
      }
      r14(descriptor) {
        return this.f1j(this.p1i(), descriptor);
      }
      f15() {
        return this.t1i(this.h1j());
      }
      g14() {
        return this.u1i(this.p1i());
      }
      h14(value) {
        return this.b1j(this.p1i(), value);
      }
      i14(value) {
        return this.w1i(this.p1i(), value);
      }
      j14(value) {
        return this.x1i(this.p1i(), value);
      }
      k14(value) {
        return this.v1i(this.p1i(), value);
      }
      l14(value) {
        return this.y1i(this.p1i(), value);
      }
      m14(value) {
        return this.z1i(this.p1i(), value);
      }
      n14(value) {
        return this.a1j(this.p1i(), value);
      }
      o14(value) {
        return this.c1j(this.p1i(), value);
      }
      p14(value) {
        return this.d1j(this.p1i(), value);
      }
      q14(enumDescriptor, index) {
        return this.e1j(this.p1i(), enumDescriptor, index);
      }
      l13(descriptor) {
        return this;
      }
      m13(descriptor) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.r1i_1.i1()) {
          this.p1i();
        }
        this.g1j(descriptor);
      }
      g1j(descriptor) {
      }
      s14(descriptor, index, value) {
        return this.b1j(this.s1h(descriptor, index), value);
      }
      t14(descriptor, index, value) {
        return this.w1i(this.s1h(descriptor, index), value);
      }
      u14(descriptor, index, value) {
        return this.x1i(this.s1h(descriptor, index), value);
      }
      v14(descriptor, index, value) {
        return this.v1i(this.s1h(descriptor, index), value);
      }
      w14(descriptor, index, value) {
        return this.y1i(this.s1h(descriptor, index), value);
      }
      x14(descriptor, index, value) {
        return this.z1i(this.s1h(descriptor, index), value);
      }
      y14(descriptor, index, value) {
        return this.a1j(this.s1h(descriptor, index), value);
      }
      z14(descriptor, index, value) {
        return this.c1j(this.s1h(descriptor, index), value);
      }
      a15(descriptor, index, value) {
        return this.d1j(this.s1h(descriptor, index), value);
      }
      b15(descriptor, index) {
        return this.f1j(this.s1h(descriptor, index), descriptor.y11(index));
      }
      c15(descriptor, index, serializer, value) {
        if (encodeElement(this, descriptor, index)) {
          this.nz(serializer, value);
        }
      }
      d15(descriptor, index, serializer, value) {
        if (encodeElement(this, descriptor, index)) {
          this.e15(serializer, value);
        }
      }
      h1j() {
        return last(this.r1i_1);
      }
      x1h() {
        return lastOrNull(this.r1i_1);
      }
      n1i(name) {
        this.r1i_1.v(name);
      }
      p1i() {
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.r1i_1.i1()) {
          tmp = this.r1i_1.z3(get_lastIndex(this.r1i_1));
        } else {
          throw SerializationException().p10('No tag in stack for requested element');
        }
        return tmp;
      }
    }
    protoOf($).g15 = beginCollection;
    protoOf($).nz = encodeSerializableValue;
    protoOf($).e15 = encodeNullableSerializableValue;
    protoOf($).h15 = shouldEncodeElementDefault;
    initMetadataForClass($, 'TaggedEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    TaggedEncoderClass = $;
  }
  return TaggedEncoderClass;
}
//region block: exports
export {
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
  NamedValueEncoder as NamedValueEncoder1lca9edk1lf89,
};
//endregion

//# sourceMappingURL=Tagged.mjs.map
